import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a freestanding kitchen island, 1.8 x 0.9 m, worktop at
// 0.9 m overhanging on the +Z (seating) side; walnut body, door fronts on -Z.
const WALNUT = "#7a5a3a";
const FRONT = "#efece6";
const WORKTOP = "#d8d5cf";
const MATTE_BLACK = "#2e2e30";

export const kitchenIsland = defineModel({
  id: "kitchen-island",
  batchId: "modern",
  name: "Kitchen island",
  tags: ["modern", "interior", "furniture", "kitchen", "storage", "counter"],
  summary: "A freestanding walnut kitchen island with a seating overhang.",
  tiles: { w: 2, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(1.6, 0.1, 0.6), color: MATTE_BLACK, position: [0, 0.05, -0.08] },
      // walnut body, set back from the +Z edge to leave the seating overhang
      { geometry: new THREE.BoxGeometry(1.7, 0.75, 0.7), color: WALNUT, position: [0, 0.475, -0.08] },
      // two door fronts on the -Z side
      { geometry: new THREE.BoxGeometry(0.6, 0.6, 0.02), color: FRONT, position: [-0.4, 0.5, -0.44] },
      { geometry: new THREE.BoxGeometry(0.6, 0.6, 0.02), color: FRONT, position: [0.4, 0.5, -0.44] },
      // thin bar handles
      { geometry: new THREE.BoxGeometry(0.18, 0.025, 0.02), color: MATTE_BLACK, position: [-0.4, 0.72, -0.455] },
      { geometry: new THREE.BoxGeometry(0.18, 0.025, 0.02), color: MATTE_BLACK, position: [0.4, 0.72, -0.455] },
      // worktop (top surface at 0.9), overhanging toward +Z
      { geometry: new THREE.BoxGeometry(1.8, 0.05, 0.9), color: WORKTOP, position: [0, 0.875, 0] },
    ];
  },
  animations: [],
});
